<template>
  <Dialog :open="open" @update:open="emitClose">
    <DialogContent class="sm:max-w-[600px]">
      <div v-if="isLoading">
        <LayupSpinner />
      </div>
      <div v-else>
        <DialogHeader>
          <DialogTitle>Change Request</DialogTitle>
          <DialogDescription>Merchant Billing and Settlements</DialogDescription>
          <DialogDescription v-if="errorMessage" class="text-red-500">
            {{ errorMessage }}
          </DialogDescription>
        </DialogHeader>
        <div class="flex flex-col gap-4">
          <div class="my-2">
            <textarea
              class="resize-none w-full h-32 p-4 border border-grey-light-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-500"
              placeholder="Please provide a detailed description of the changes you would like to request."
              v-model="requestDescription"
            ></textarea>
          </div>
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" @click="emitClose">Cancel</Button>
          <Button type="button" class="w-auto" @click.prevent="onSubmit" :disabled="!requestDescription">
            Send Request
          </Button>
        </DialogFooter>
      </div>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import LayupSpinner from '@/components/common/LayupSpinner.vue';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { ref } from 'vue';

defineProps({
  open: Boolean,
  isLoading: Boolean,
  errorMessage: String,
});

const emit = defineEmits(['update:open', 'submit']);

const requestDescription = ref('');

const emitClose = () => {
  emit('update:open', false);
};

const onSubmit = () => {
  emit('submit', requestDescription.value);
};
</script>
